import {usePlaneduHttpService} from "../service/planedu.http.service";
import {ResetPasswordEntity} from "../entity/reset-password.entity";

export function useResetPasswordService() {
    const httpService = usePlaneduHttpService<ResetPasswordEntity>('users/update-password');
    return {
        ...httpService,
    }
}
